import {
  Badge,
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
} from "antd";
import React, { useState } from "react";
import { labelComponent } from "../../util/UtilComponents";
import { isExporter, isManufacturerCumExporter } from "../../util/helper";
import { useSelector } from "react-redux";
import Upload from "../../components/Upload";
import { getLabel, isValidElement, isValidString } from "../../util/ApiHelper";
import { InfoCircleOutlined } from "@ant-design/icons";
import moment from "moment";

const OfferProductForm = ({
  form,
  onFinish,
  uniqueProductsUnitList,
  fileList,
  visibleAttachments,
  validateTextArea,
  currency,
  selectedUOM,
  paymentTerms,
  authUser,
  isEditDisabled,
  isMobile,
  history,
  setSelectedProductId,
  setSelectedCategoryId,
  selectedCurrencies,
  setSelectedCurrencies,
  setSelectedHsCodeId,
  handleChangeProductCategory,
  handleHSCodeSearch,
  filteredHsCodeData,
  hsCodeData,
  onUpload,
  onRemove,
}) => {
  const { Option } = Select;
  const { TextArea } = Input;
  const countries = useSelector(({ common }) => common.countries);
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const categoryList = useSelector((state) => state.myProducts.categoryList);
  const FOR_DESTINATIONS = [
    "Mundra Port",
    "Nhava Sheva",
    "Kakinada",
    "Gandhidham",
    "Chennai",
  ];

  return (
    <Form form={form} onFinish={onFinish} scrollToFirstError={true}>
      <Row gutter={16}>

        <Col span={8} xs={24} sm={12} md={8}>
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            label="Product Category"
            name="productCategory"
            rules={[
              {
                required: true,
                message: "Product Category is required",
              },
            ]}
          >
            <Select
              showSearch
              size="large"
              name="productCategory"
              placeholder="Choose Product Category"
              dropdownStyle={{ maxHeight: "200px" }}
              onChange={handleChangeProductCategory}
              getPopupContainer={(trigger) => trigger.parentNode}
              listItemHeight={10}
              listHeight={250}
              filterOption={(input, option) => {
                const children = option?.children ?? "";
                const optionText = children.props?.children ?? "";
                return optionText.toLowerCase().includes(input.toLowerCase());
              }}
            >
              {categoryList?.map((option) => (
                <Select.Option key={option.id} value={option.id}>
                  <div style={{ whiteSpace: "normal" }}>
                    {option.name.charAt(0).toUpperCase() +
                      option.name.slice(1).toLowerCase()}
                  </div>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8} xs={24} sm={12} md={8}>
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            label="HS code"
            name="hscode"
            rules={[
              {
                required: true,
                message: "HS code is required",
              },
            ]}
          >
            <Select
              showSearch
              size="large"
              name="hscode"
              placeholder="Choose HS code / Item Description"
              filterOption={false}
              disabled={isEditDisabled}
              getPopupContainer={(trigger) => trigger.parentNode}
              onSearch={handleHSCodeSearch}
            >
              {isValidElement(filteredHsCodeData)
                ? filteredHsCodeData?.map((option) => (
                  <Option key={option.id} value={option.id}>
                    <div style={{ whiteSpace: "normal" }}>
                      {option.code} -{" "}
                      {option.description.replace(/[\n\r"]/g, "")}
                    </div>
                  </Option>
                ))
                : hsCodeData?.map((option) => (
                  <Option key={option.id} value={option.id}>
                    <div style={{ whiteSpace: "normal" }}>
                      {option.code} -{" "}
                      {option.description.replace(/[\n\r"]/g, "")}
                    </div>
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8} xs={24} sm={12} md={8} >
          <Form.Item
            labelCol={{ span: 24 }}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            wrapperCol={{ span: 24 }}
            label="Product Name"
            name="productName"
            rules={[
              {
                required: true,
                message: "Product Name is required",
              },
            ]}
          >
            <Input
              maxLength={70}
              showCount
              placeholder="Example: Parboiled Rice"
              size={"large"}
              autoComplete="off"
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={12}>
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            label={labelComponent("Unit of Measurement (UOM)")}
            name="uom"
            rules={[{ required: true, message: "UOM is required" }]}
          >
            <Select
              showSearch
              size="large"
              placeholder="Select Unit of Measurement"
              disabled={isEditDisabled}
            >
              {uniqueProductsUnitList?.map((option) => (
                <Option key={option.label} value={option.label}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={8} xs={24} sm={12} md={6}>
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            label={labelComponent("Currency")}
            name="currency"
            initialValue={"USD"}
            rules={[
              {
                required: true,
                message: "Currency is required",
              },
            ]}
          >
            <Select
              style={{ width: "100%" }}
              placeholder="Currency"
              showSearch
              optionFilterProp="children"
              value={selectedCurrency}
              onChange={(value) => {
                setSelectedCurrency(value);
                form.setFieldsValue({ currency: value });
              }}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {[
                ...new Set([
                  ...selectedCurrencies,
                  ...(countries
                    ?.filter((country) => country.currencyCode)
                    .map((country) => country.currencyCode) || []),
                ]),
              ].map((currencyCode) => (
                <Option
                  key={currencyCode}
                  value={currencyCode}
                  disabled={
                    selectedCurrencies.length >= 2 &&
                    !selectedCurrencies.includes(currencyCode)
                  }
                >
                  {currencyCode}
                  {selectedCurrencies.length >= 2 &&
                    !selectedCurrencies.includes(currencyCode) &&
                    " (Not Allowed)"}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={8} xs={24} sm={12} md={6}>
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            label={labelComponent(
              `${selectedCurrency === "INR" ? "FOR Price" : "FOB Price"} ${selectedUOM ? `/ ${selectedUOM}` : ""
              }`,
              "Price per unit of measurement"
            )}
            name="price"
            rules={[{ required: true, message: "Price is required" }]}
          >
            <InputNumber
              min={1}
              placeholder="Enter Price"
              style={{ width: "100%" }}
              className="no-spinner"
            />
          </Form.Item>
        </Col>

        {selectedCurrency === "INR" && (
          <Col span={8} xs={24} sm={12} md={12}>
            <Form.Item
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label={labelComponent("FOR Destination")}
              name="forDestination"
              rules={[
                { required: true, message: "FOR Destination is required" },
              ]}
            >
              <Select
                placeholder="Select FOR Destination"
                showSearch
                size="large"
                getPopupContainer={(trigger) => trigger.parentNode}
              >
                {
                  FOR_DESTINATIONS.map((destinationPort) => (
                    <Option key={destinationPort} value={destinationPort}>
                      {destinationPort}
                    </Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Col>
        )}

        <Col span={8} xs={24} sm={12}>
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            label={labelComponent("Offer Expiry date")}
            name="expiryDate"
            rules={[{ required: true, message: "Expiry date is required" }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format="DD-MM-YYYY"
              getPopupContainer={(trigger) => trigger.parentNode}
              disabledDate={(current) =>
                current && current < moment().startOf("day")
              }
            />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            label={labelComponent("Comments")}
            name="comments"
            rules={[
              { validator: validateTextArea },
              { required: true, message: "Comments is required" },
            ]}
          >
            <TextArea
              showCount
              maxLength={200}
              rows={10}
              placeholder={"Enter Remarks if any"}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <div className="sub-header">Product Images</div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            {fileList.slice(0, visibleAttachments).map((file, index) => (
              <Upload
                key={index}
                index={index}
                id={index}
                src={file?.src}
                label={
                  isValidString(file?.label) ? file?.label : getLabel(index)
                }
                originalName={file?.originalName}
                onUpload={onUpload}
                onRemove={onRemove}
              />
            ))}
          </div>
        </Col>
        <Col>
          <div className="upload-tips gx-mt-4">
            <div className="header" style={{ display: "flex" }}>
              <InfoCircleOutlined /> &nbsp; Tips{" "}
            </div>
            <div className="desc">
              <Badge
                status="default"
                text="Supported file types: .jpg, .jpeg, .png"
              />
              <br />
              <Badge status="default" text="File must not more than 5MB" />
              <br />
              <Badge
                status="default"
                text="Make sure you have good resolution"
              />
              <br />
              <Badge
                status="default"
                text="Photo resolution must be more than 600x600"
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row className="gx-mt-4">
        <Col span={24}>
          <Form.Item
            className="gx-text-center gx-mr-3"
            style={{
              justifyContent: isMobile ? "center" : "end",
              display: "flex",
              flex: 1,
            }}
          >
            <Button
              type="secondary"
              size="large"
              style={{ width: 150 }}
              onClick={() => history.goBack()}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              style={{ width: 150 }}
            >
              Save
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default OfferProductForm;
